import React, { useState, useEffect, useRef } from "react";
import stocai from "../../../assets/Stocai.png";
import { Send } from "lucide-react";

const DumpBooth = ({ userId }) => {
  console.log("userId Dumpbooth : ", userId);
  const [message, setMessage] = useState("");
  const [strikethroughMessages, setStrikethroughMessages] = useState([]);
  const [isReply, setIsReply] = useState(false);
  // const [hasSubmitted, setHasSubmitted] = useState(false);
  const textareaRef = useRef(null);

  useEffect(() => {
    // fetchStrikethroughMessages();
    const fetchStrikethroughMessages = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${userId}/dumps`
        );
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch dumps:", errorData.detail);
          return;
        }

        const data = await response.json();
        console.log("This is the dump:", data);

        if (Array.isArray(data) && data.length > 0) {
          const texts = data.map((item) => item.text);
          setStrikethroughMessages(texts);
        } else {
          setStrikethroughMessages([]);
        }
      } catch (err) {
        console.error("Error fetching dumps:", err);
      }
    };
    fetchStrikethroughMessages();
  }, [userId]);

  const handleInputChange = (e) => {
    setMessage(e.target.value);
    setIsReply(false);
  };

  const handleTextareaFocus = () => {
    if (isReply) {
      setMessage("");
      setIsReply(false);
    }
  };

  const handleSend = async () => {
    if (message.trim() === "") return;

    // Always add the message to the strikethrough list
    setStrikethroughMessages((prev) => [message, ...prev]);
    console.log("this is the dump by user ", message);

    const response = getRegexReply(message);
    setMessage(response);
    setIsReply(true);

    textareaRef.current?.blur();

    // insertion os the dump into the db call
    const payload = {
      userid: userId,
      text: message,
    };
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${userId}/dumps`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      console.log("This is the data", data);
      if (response.ok) {
        console.log("sucess fully appendeed");
      }
    } catch (error) {
      console.error("Error creating session:", error);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const getRegexReply = (text) => {
    const patterns = [
      {
        category: "Validation",
        regex: new RegExp(
          String.raw`\b(?:` +
            [
              `i\\s(?:hate|hate\\smyself|can't|regret(?:ting|ted)?|messed\\s?up|feel\\s(?:like\\s)?shit|feel\\sbroken|failed|am\\s(?:sad|anxious|worried|tired|very\\s+tired|so\\s+tired))`,
              `hate`,
              `hate\\smyself`,
              `feel\\s(?:like\\s)?shit`,
              `feel\\sbroken`,
              `messed\\s?up`,
              `regret(?:ting|ted)?`,
              `fail`,
              `failed`,
              `failure`,
              `worthless`,
              `useless`,
              `pathetic`,
              `sad(?:ness)?`,
              `anxiety`,
              `anxious`,
              `worr(?:y|ied)`,
              `broken`,
            ].join("|") +
            `)\\b`,
          "i" // case-insensitive flag
        ),
        replies: [
          "Dang, that sounds like it's been bottled up for a while.",
          "Yeah, that hit hard. No need to hold back here.",
          "You've been carrying that, huh? Say it all if you need to.",
          "That's a lot - and it deserves to be out.",
          "Say more if it's still sitting heavy.",
          "You just dropped truth. Don't stop now if there's more.",
          "If your head's still spinning with it, get it all out. This is the spot.",
        ],
      },
      {
        category: "Containment",
        regex: new RegExp(
          String.raw`\b(?:` +
            [
              `i'm\\s(?:overwhelmed|drowning)`,
              `i\\scan't\\s(?:breathe|cope|understand\\sanything)`,
              `(?:everything's\\s)?too\\smuch`,
              `overwhelm(?:ed|ing)?`,
              `panic(?:king)?`,
              `spiral(?:ing|ed)?`,
              `(?:breaking|broke)\\sdown`,
              `losing\\sit`,
              `out\\sof\\scontrol`,
              `chaos(?:tic)?`,
              `clueless`,
              `no\\sidea`,
            ].join("|") +
            `)\\b`,
          "i"
        ),
        replies: [
          "You can dump the whole thing here. This space doesn't break.",
          "No filter needed - just keep going if your chest still feels tight.",
          "Everything you're feeling is welcome here. All of it.",
          "This spot is made for the stuff that doesn't fit anywhere else.",
          "You don't have to shut it down. Let it pour out.",
          "You've let some of it out - more's okay too.",
          "Nothing you drop here is too much. Seriously.",
        ],
      },
      {
        category: "Permissioning",
        regex: new RegExp(
          String.raw`\b(?:` +
            [
              `i\\s(?:don't\\s(?:know|get\\sit|deserve\\sto\\sfeel\\s(?:like|this)))`, // 🔧 fixed missing parenthesis
              `can't\\s(?:explain|even\\sfeel|tell)?`,
              `shouldn't\\sfeel\\sthis\\sway`,
              `should\\s(?:be\\s(?:grateful|stronger))`,
              `feel\\s(?:nothing|numb|off|low)`,
              `am\\s(?:confused|numb|off|blank|low|not\\sokay)`,
              `i'?m\\snot\\sokay`,
              `(?:m|'?m)\\s(?:confused|numb|off|low|not\\sokay)`,
              `i\\sdon't\\sdeserve\\sto\\sfeel`,
              `what's\\swrong\\swith\\sme`,
              `why\\sam\\si\\slike\\sthis`,
              `others\\shave\\sit\\sworse`,
              `probably\\sjust\\sbeing\\sdramatic`,
              `flat`,
              `emotionally\\sflat`,
              `it's\\sstupid\\sto\\sfeel\\sthis\\sway`,
              `meh`,
              `blank`,
            ].join("|") +
            `)\\b`,
          "i"
        ),
        replies: [
          "You don't need to have the right words - just get it off your chest.",
          "No need to clean it up or make it make sense.",
          "Feeling messy? Say it messy. That's what this is for.",
          "You're not here to solve it. You're here to say it.",
          "It's okay if you don't even know what you're feeling - just type.",
          "Let it be raw, ugly, confusing. It's still allowed.",
          "Don't overthink. Just say what's screaming inside.",
        ],
      },
      {
        category: "Vented Aggression",
        regex: new RegExp(
          String.raw`\b(?:` +
            [
              `fuck(?:ing)?`,
              `shit`,
              `bastard`,
              `asshole`,
              `bitch`,
              `moron`,
              `punch`,
              `want\\sto\\spunch`,
              `wish\\sthey\\swould\\sdie`,
              `i\\scould\\skill`,
              `i\\scan't\\sstand\\s(?:him|her|them|my\\s(?:boss|manager|mom|dad|wife|husband|partner|colleague|coworker|ex|girlfriend|boyfriend))`,
              `hate\\smy\\s(?:boss|manager|mom|dad|wife|husband|partner|colleague|coworker|ex|girlfriend|boyfriend)`,
              `my\\s(?:boss|manager|mom|dad|wife|husband|partner|colleague|coworker|ex|girlfriend|boyfriend)\\sis\\sa\\s.*`,
              `my\\s(?:boss|manager|mom|dad|wife|husband|partner|colleague|coworker|ex|girlfriend|boyfriend)\\sruins\\severything`,
              `why\\sis\\smy\\s(?:boss|manager|mom|dad|wife|husband|partner|colleague|coworker|ex|girlfriend|boyfriend)\\slike\\sthis`,
              `i'?m\\sso\\sdone\\swith\\smy\\s(?:boss|manager|mom|dad|wife|husband|partner|colleague|coworker|ex|girlfriend|boyfriend)`,
            ].join("|") +
            `)\\b`,
          "i"
        ),
        replies: [
          "Whew. That's pure fire. Say whatever else needs to come out.",
          "You're safe to rage here. No one's judging.",
          "Sounds like they really crossed a line. Say more if you need to.",
          "No filters. Let it rip if that's what your chest needs.",
          "You're not alone in feeling that level of heat.",
          "Sometimes that kind of anger just needs air. Go on.",
          "Whatever they did - this space can handle your side of it.",
        ],
      },
    ];

    for (const pattern of patterns) {
      if (pattern.regex.test(text)) {
        const rand = Math.floor(Math.random() * pattern.replies.length);
        return pattern.replies[rand];
      }
    }

    return "This space is here. Say what you need.";
  };

  // POST: Send user's dumped message to the backend
  // const postUserDumpMessage = async () => {
  //   const payload = {
  //     message: message,
  //     timestamp: new Date().toISOString(),
  //   };
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BACKEND_API_URL}/users/{userId}/dump`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(payload),
  //       }
  //     );
  //     const data = await response.json();
  //     console.log("Message submitted:", data);
  //     if (response.ok) {
  //       // Handle success state (e.g., notification or UI update)
  //     }
  //   } catch (error) {
  //     console.error("Error sending dump message:", error);
  //   }
  // };

  // GET: Fetch dumped strikethrough messages from backend
  // const fetchStrikethroughMessages = async () => {
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BACKEND_API_URL}/users/{userId}/dump/history`
  //     );
  //     const data = await response.json();
  //     setStrikethroughMessages(data.messages); // assuming `data.messages` is an array
  //   } catch (error) {
  //     console.error("Error fetching messages:", error);
  //   }
  // };

  return (
    <div className="bg-[#FFFFFF] rounded-2xl p-4 lg:p-5 w-full shadow-sm text-sm text-gray-800">
      {/* Coach Header */}
      <div className="flex items-start space-x-3 mb-4">
        <img
          src={stocai}
          alt="Coach"
          className="w-10 h-10 rounded-full object-cover"
        />
        <div>
          <div className="text-[#1D1D1D] font-medium text-sm lg:text-[16px]">
            Sto
          </div>
          <div className="text-xs font-gotham font-medium text-[#888888]">
            Your Clarity Panda
          </div>
        </div>
      </div>

      {/* Header & Tagline */}
      <div className="text-[#323232] font-gotham font-bold mb-1 text-sm lg:text-xl">
        Dump booth
      </div>
      <div className="text-[11px] lg:text-[12px] text-[#888888] font-gotham font-medium leading-tight mb-4">
        Type. Vent. Breathe. <br />
        No rules, no replies — just release.
      </div>

      {/* Textarea & Send Button */}
      <div className="relative">
        <textarea
          ref={textareaRef}
          value={message}
          onChange={handleInputChange}
          onKeyDown={handleKeyPress}
          onFocus={handleTextareaFocus}
          className={`lg:h-32 w-full font-gotham font-normal text-sm p-3 rounded-lg mb-4 italic resize-none transition-colors duration-200 border focus:border-[#54B0AF] focus:bg-white focus:outline-none ${
            isReply
              ? "bg-[#F5F5F5] text-[#1D1D1D] italic caret-transparent border-[#54B0AF]"
              : message.trim()
              ? "bg-white text-[#1D1D1D] not-italic border-[#E0E0E0] "
              : "bg-[#F5F5F5] text-[#CACACA] italic border-[#E0E0E0] "
          }`}
          placeholder="Dump your thoughts here. (Press Enter to submit)"
        />

        {!isReply && message.trim() !== "" && (
          <button
            onClick={handleSend}
            className="absolute bottom-7 right-2 w-7 h-7 2xl:w-10 2xl:h-10 bg-[#54B0AF] hover:bg-teal-600 text-white rounded-full shadow-md transition-all duration-200 flex justify-center items-center"
          >
            <Send
              size={16}
              className="transform rotate-45 -translate-x-[1px]"
            />
          </button>
        )}
      </div>

      {/* Strikethrough Messages (always show 2) */}
      <div className="text-[#CACACA] line-through font-gotham font-medium text-[11px] lg:text-xs space-y-2">
        {strikethroughMessages.slice(0, 2).map((msg, index) => (
          <div key={index}>{msg}</div>
        ))}
      </div>
    </div>
  );
};

export default DumpBooth;
